const CTN_DISCOUNT_CODES = {
  1: 'CTNHQ30',
  2: 'CNT2PRODUCT',
  3: 'CNT3PRODUCT',
  4: 'CNT4PRODUCT',
};

export default CTN_DISCOUNT_CODES;